import React from "react"
import AnimatedBar from "../../../../../../ui/molecules/AnimatedBar"
import { Basket } from "../../../../state/checkoutTypes"

interface Props {
  basket: Basket
}

const getFreeShippingProgress = (subtotal: number, freeThreshold: number) => {
  if (subtotal >= freeThreshold) {
    return 100
  }

  return 100 - ((freeThreshold - subtotal) / freeThreshold) * 100
}

const FreeShippingAnimation = ({ basket }: Props) => {
  return (
    <div>
      <AnimatedBar
        progress={
          basket.shipping.hasFreeShippingPromo
            ? 100
            : getFreeShippingProgress(
                basket.recap.subtotal.price,
                basket.shipping?.freeThreshold ?? 0
              )
        }
        startDelay={400}
        style={{
          height: 6,
        }}
      />
    </div>
  )
}

export default FreeShippingAnimation
